var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const asyncSuspense = (func, name = 'suspense', maxRetries = 3) => () => {
    let status = 'init';
    let result;
    let retryCount = 0;
    let lastError;
    const executeWithRetry = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            return yield func();
        }
        catch (error) {
            if (retryCount < maxRetries) {
                retryCount++;
                console.warn(`${name} failed, retrying (${retryCount}/${maxRetries})...`);
                // Exponential backoff
                yield new Promise((resolve) => setTimeout(resolve, Math.pow(2, retryCount) * 1000));
                return executeWithRetry();
            }
            throw error;
        }
    });
    const loading = executeWithRetry()
        .then((r) => {
        result = r;
        status = 'done';
    })
        .catch((error) => {
        lastError = error;
        console.error(`${name} loading failed after ${maxRetries} retries:`, error);
        status = 'error';
    });
    return () => {
        if (status === 'init') {
            throw loading;
        }
        else if (status === 'error') {
            // Prefer the original error if available, else a descriptive fallback
            if (lastError instanceof Error)
                throw lastError;
            throw new Error(`${name} loading failed after ${maxRetries} retries ${lastError ? `: ${String(lastError)}` : ''}`);
        }
        return result;
    };
};
